import { infiniteQueryOptions, useInfiniteQuery } from "@tanstack/react-query"
import { feedKeys } from "../model/keys"
import type { FeedList, FeedSort } from "../model/types"
import { getCardFeed, getDailyQuestionFeed } from "./client"

const CARD_FEED_PAGE_SIZE = 5
const DAILY_QUESTION_FEED_PAGE_SIZE = 10

function getNextFeedCursor(lastPage: FeedList): string | undefined {
	if (lastPage.has_more && lastPage.next_cursor) return lastPage.next_cursor
	return undefined
}

export function cardFeedQueryOptions(sort: FeedSort) {
	return infiniteQueryOptions({
		queryKey: feedKeys.cardFeed(sort),
		queryFn: ({ pageParam }) =>
			getCardFeed({ limit: CARD_FEED_PAGE_SIZE, cursor: pageParam, sort }),
		initialPageParam: null as string | null,
		getNextPageParam: getNextFeedCursor,
		refetchOnMount: "always",
		staleTime: 0,
	})
}

/**
 * Лента «Вопрос дня». Первая страница несёт `locked` / `current_question` /
 * `user_has_answered` (+ `user_answer` — см. `selectCurrentUserAnswer`); при
 * locked=true бэк отдаёт items=[].
 */
export function dailyQuestionFeedQueryOptions(sort: FeedSort) {
	return infiniteQueryOptions({
		queryKey: feedKeys.dailyQuestionFeed(sort),
		queryFn: ({ pageParam }) =>
			getDailyQuestionFeed({
				limit: DAILY_QUESTION_FEED_PAGE_SIZE,
				cursor: pageParam,
				sort,
			}),
		initialPageParam: null as string | null,
		getNextPageParam: getNextFeedCursor,
		refetchOnMount: "always",
		staleTime: 0,
	})
}

export function useCardFeed(sort: FeedSort) {
	return useInfiniteQuery(cardFeedQueryOptions(sort))
}

export function useDailyQuestionFeed(sort: FeedSort) {
	return useInfiniteQuery(dailyQuestionFeedQueryOptions(sort))
}
